module.exports = __webpack_public_path__ + "static/media/29DUNON14.ce309493.jpg";